// extracted by mini-css-extract-plugin
export default {"plus":"mQuLPnAD29mfBzSacd23","minus":"zmbkHPmrjSKlcEt_Jbkd","x":"ttlwAG10MRAFjS55rsbr"};